export const ROUTES = {
  HOME: "/",
  SIGN_UP: "/sign-up",

  CREATE: "create",
  BATCH_CREATE: "batch-create",
  UPDATE: "update",
  ID: ":id",
  ID_2: ":id2",
  SETTINGS: "settings",
  DETAILS: "details",

  HRM: {
    EMPLOYEES: "/employees",
    ORG_CHART: "/organization-chart",
    SENIORITY: "/seniority",
    PERMANENT: "/permanent",
    DEPUTATION: "/deputation",
    TRANSFER_CANDIDATES: "/transfer-candidates",
    TRANSFERS: "/transfers",
    PROMOTION_CANDIDATES: "/promotion-candidates",
    PROMOTION: "/promotion",
    RESIGNATION: "/resignation",
    RELEASE: "/release",
    NOTIFICATIONS: "/notifications",
    RETIREMENTS: "/retirements",
    CENTRAL_ATTENDANCE: "/central-attendance",
    ACR: "/acr",
    APR: "/apr",
    DOSSIER: "/dossier",
    POSITIONS: "/positions",
    POSITION_TREE: "/position-tree",
    PROVIDENT_FUND: "/gpf",
    PUNISHMENT: "/punishment",
    LEAVE: "/leave",
    SETTINGS: "/hrm-settings",
    PROFILE: "/profile",
    MANPOWER_REPORTS: "/manpower-reports",
    PROMOTION_REPORTS: "/promotion-reports",
    PRL_REPORTS: "/prl-reports",
    PENSION_REPORTS: "/pension-reports",
    RESIGNATION_REPORTS: "/resignation-reports",
    RETIREMENT_REPORTS: "/retirement-reports",
    RELEASE_REPORTS: "/release-reports",
    YEARLY_REPORTS: "/yearly-reports",
    REWARD_REPORTS: "/reward-reports",
    JOB_REPORTS: "/job-reports",
    MANPOWER_SUMMARY_REPORTS: "/manpower-summary-reports",
    MANPOWER_DETAILS_REPORTS: "/manpower-details-reports",
    MANPOWER_RECRUIT_REPORTS: "/manpower-recruit-reports",
    ACR_REPORTS: "/acr-reports",
    DECEASED_LIST: "/deceased-list",
    DECEASED: "/deceased",
    TERMINATION_LIST: "/termination-list",
    TERMINATION: "/termination",
    EXTRA_POSITION_INFORMATIONS: "/extra-position-informations",
    INTERCHANGE_TRANSFERS: "/interchange-transfers",
    FILE_INQUIRY: "/file-inquiry",
  },

  INVENTORY: {
    EMPLOYEES: "/employees-distribution",
    ASSETS: "/assets",
    PRODUCTS: "/products",
    STOCK: "/stock",
    PROCUREMENTS: "/procurements",
    SETTINGS: "/settings",
    ROOM_CONFIGURATION: "/room-configuration",
    CONFERENCE_ROOM: "/conference-room",
    BUDGET: "/budget",
    FORECASTING: "/forecasting",
    REQUISITION: "/requisition",
    WARRANTY: "/warranty",
    MAINTENANCE: "/maintenance",
    SOFTWARE_INVENTORY: "/software-inventory",
  },

  PROCUREMENT: {
    ANNUAL_PROCUREMENT_PLAN: "/annual-procurement-plan",
    VENDORS: "/vendors",
    DEMANDS: "/demands",
    PROCUREMENTS: "/procurement",
    COMMITTEE: "/committee",
  },

  TASK_MANAGEMENT: {
    ALL_TASKS: "/all-tasks",
    SUB_TASKS: "/sub-tasks",
    OWN_TASKS: "/own-tasks",
    SHARED_TASKS: "/shared-tasks",
    ASSIGNED_TASKS: "/assigned-tasks",
    ASSIGNED_SUB_TASKS: "/assigned-sub-tasks",
    SHARED_SUB_TASKS: "/shared-sub-tasks",
    ARCHIVED_TASKS: "/archived-tasks",
    SETTINGS: "/task-management-settings",
  },

  TICKETS: {
    E_TICKETS: "/tickets",
    MY_TICKETS: "/my-tickets",
    REQUESTED_TICKETS: "/requested-tickets",
    ASSIGNED_TICKETS: "/assigned-tickets",
    SETTINGS: "/tickets-settings",
  },

  NOTIFICATION: {
    NOTIFICATIONS: "/notifications",
  },
};
